exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2WMZp3NXzrjWOr-f5xLDHY{display:-webkit-box;display:-ms-flexbox;display:flex}._2WMZp3NXzrjWOr-f5xLDHY,.YGCHzKi_kbbph5KauFWlQ{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0;overflow:hidden}._398KWKTBfOBm6x08XqV0QH{width:100%}html[dir] ._30q0DIFfdy8jxJMZfeoa5T{margin-top:3px}html[dir=ltr] ._30q0DIFfdy8jxJMZfeoa5T{margin-right:6px!important}html[dir=rtl] ._30q0DIFfdy8jxJMZfeoa5T{margin-left:6px!important}", ""]);

// exports
exports.locals = {
	"wrapper": "_2WMZp3NXzrjWOr-f5xLDHY",
	"fileshub": "YGCHzKi_kbbph5KauFWlQ",
	"consumerfileshub": "_398KWKTBfOBm6x08XqV0QH",
	"favoriteButtonInHeader": "_30q0DIFfdy8jxJMZfeoa5T"
};